import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';
import styles from './style.module.css';
import { Button } from '@/components/ui/button';

interface ModalSummaryProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  formData: FormData;
}

export function Summary({ open, onOpenChange, formData }: ModalSummaryProps) {
  const [data, setData] = useState<Record<string, string>>({});

  useEffect(() => {
    const formDataObject: Record<string, string> = {};
    formData.forEach((value, key) => {
      if (typeof value === 'string') {
        formDataObject[key] = value;
      }
    });
    setData(formDataObject);
  }, [formData]);

  function formatDate(dateString: string | undefined | null): string {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}/${date.getFullYear()}`;
  }

  function formatTime(timeString: string | undefined | null): string {
    if (!timeString) return 'N/A';

    const [time, period] = timeString.split(' ');
    const [hours, minutes] = time.split(':').map(Number);

    let adjustedHours = hours;
    if (period === 'PM' && hours !== 12) {
      adjustedHours += 12;
    } else if (period === 'AM' && hours === 12) {
      adjustedHours = 0;
    }

    return `${adjustedHours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
  }

  const handleSubmit = () => {};

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle className="text-xl font-[bold] text-center">
          Summary
        </DialogTitle>
        <DialogClose asChild />

        <div className="flex justify-center p-5">
          <div className="flex flex-col w-full max-w-[600px] p-5 rounded-lg bg-[#FFF]">
            <div className="flex flex-row items-center mb-2">
              <h3 className={styles['section-title']}>Title - </h3>
              <p className={styles['section-content']}>{data?.title}</p>
            </div>
            <div className="mb-5">
              <p className={styles['section-content']}>
                <strong>Start Date:</strong> {formatDate(data?.startDate)} -{' '}
                <strong>End Date:</strong> {formatDate(data?.endDate)}
              </p>
            </div>
            <div className="mb-5">
              <p className={styles['section-content']}>
                <strong>Start Time:</strong> {formatTime(data?.startTime)} -{' '}
                <strong>End Time:</strong> {formatTime(data?.endTime)}
              </p>
            </div>
            <div className="mb-5">
              <h3 className={styles['section-title']}>Options</h3>
              <p className={styles['section-content']}>
                <strong>Status:</strong> {data?.repeatOption}
              </p>
              <p className={styles['section-content']}>
                <strong>Description:</strong> {data?.description}
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-end">
          <Button variant="black" onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
